import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { handleAxiosError } from "./responses/AxiosResponseHandler";

class GetAllCitiesApi {

    private authClient: AuthClient;
    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public async getAllCities() {

        try {

            const authenticationResponse = this.authClient.getAuthenticationResponse();
            const response = await axios.get(
                `${this.authClient.getApiRoot()}/cities/all`,
                {
                    headers: {
                        Authorization: `Bearer ${authenticationResponse?.token}`,
                    },
                }
            );

            return {
                statusCode: response.status,
                errorMessage: "",
                data: response.data 
            };

        } catch (error) {
            const errorResponse = handleAxiosError(error as AxiosError);
            return {
                statusCode: errorResponse.statusCode,
                errorMessage: errorResponse.errorMessage,
            }
        }
    }
}

export default GetAllCitiesApi;